import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#409fff"
        }
    },
    // Migração MUI v4 -> v9: a chave `overrides` foi substituída por `components.styleOverrides`
    // no v5. Deixar como estava não daria erro em runtime — o MUI simplesmente IGNORA a chave
    // desconhecida, e o DialogContent perderia o fundo cinza sem nenhum aviso.
    components: {
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    backgroundColor: "#E4E6E8"
                }
            }
        }
    }
})

export {theme}